/* ══════════════════════════════════════════════════════════
   Collection Page — Vanilla JS
   Sort dropdown, grid toggle, mobile filter drawer,
   price range slider, filter form submission
   ══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* The page window ("Showing 1–24 of 126") travels on the toolbar slot, because
     only the grid section can see the paginate object. Module scope so the
     client-side filters can restore it after they clear. */
  var pageWindow = null;

  /* Custom filters are client-side, so Shopify does not know to carry them
     into paginate.next.url. Store them in explicit URL parameters and merge
     all collection state into pagination, sort, and native-chip links. */
  var CLIENT_FILTER_PARAM_PREFIX = 'aykah_filter_';
  var CLIENT_FILTER_TYPES = ['type', 'color', 'material', 'size', 'availability'];

  function isClientFilterParam(key) {
    return key.indexOf(CLIENT_FILTER_PARAM_PREFIX) === 0;
  }

  function isCollectionStateParam(key) {
    return key === 'sort_by' || key.indexOf('filter.') === 0 || isClientFilterParam(key);
  }

  function syncCollectionStateLinks() {
    var sourceParams = new URLSearchParams(window.location.search);
    var links = document.querySelectorAll(
      '.pagination a[href], a.sort-option[href], .toolbar-chiprow a.filter-chip-x[href]'
    );

    links.forEach(function (link) {
      var targetUrl;
      try {
        targetUrl = new URL(link.getAttribute('href'), window.location.href);
      } catch (error) {
        return;
      }

      if (targetUrl.origin !== window.location.origin ||
          targetUrl.pathname !== window.location.pathname) return;

      var isSortLink = link.classList.contains('sort-option');
      var isNativeRemoveLink = link.classList.contains('filter-chip-x');
      var selectedSort = isSortLink ? targetUrl.searchParams.get('sort_by') : null;
      var targetStateKeys = [];

      targetUrl.searchParams.forEach(function (value, key) {
        var shouldClear = isNativeRemoveLink
          ? (key === 'sort_by' || isClientFilterParam(key))
          : isCollectionStateParam(key);
        if (shouldClear && targetStateKeys.indexOf(key) === -1) {
          targetStateKeys.push(key);
        }
      });
      targetStateKeys.forEach(function (key) {
        targetUrl.searchParams.delete(key);
      });

      var copiedKeys = [];
      sourceParams.forEach(function (value, key) {
        var shouldCopy = isNativeRemoveLink
          ? (key === 'sort_by' || isClientFilterParam(key))
          : isCollectionStateParam(key);
        if (!shouldCopy ||
            (isSortLink && key === 'sort_by') ||
            copiedKeys.indexOf(key) !== -1) return;

        copiedKeys.push(key);
        sourceParams.getAll(key).forEach(function (paramValue) {
          targetUrl.searchParams.append(key, paramValue);
        });
      });

      if (isSortLink && selectedSort) {
        targetUrl.searchParams.set('sort_by', selectedSort);
      }

      link.setAttribute('href', targetUrl.pathname + targetUrl.search + targetUrl.hash);
    });
  }

  /* ── DOM Ready ── */
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initLayoutSlot();
    initSortDropdown();
    initGridToggle();
    initMobileFilterDrawer();
    initPriceRangeSliders();
    initFilterCheckboxes();
    initFilterSectionToggles();
    initClientSideFilters();
    initShowMore();
    updateFilterGroupBadges();
    syncCollectionStateLinks();
  }

  /* ──────────────────────────────────────────────
     Move the filter rail and the toolbar into the grid flex container
     ────────────────────────────────────────────── */
  function initLayoutSlot() {
    var desktopFilters = document.getElementById('desktop-filters');
    var slot = document.getElementById('desktop-filters-slot');
    if (desktopFilters && slot) {
      slot.parentNode.replaceChild(desktopFilters, slot);
      /* CSS classes (hidden lg:block) handle responsive visibility */
    }

    /* Figma 160:135 — the toolbar is the first row of the main column, which is
       what lines "Showing …" up with the rail's Filters header. Read the page
       window off the slot before the swap discards it. */
    var toolbar = document.getElementById('collection-toolbar');
    var toolbarSlot = document.getElementById('collection-toolbar-slot');
    if (toolbar && toolbarSlot) {
      var total = parseInt(toolbarSlot.getAttribute('data-showing-total'), 10);
      var from = parseInt(toolbarSlot.getAttribute('data-showing-from'), 10);
      var to = parseInt(toolbarSlot.getAttribute('data-showing-to'), 10);
      toolbarSlot.parentNode.replaceChild(toolbar, toolbarSlot);

      if (total > 0) {
        pageWindow = { from: from, to: to, total: total };
        var countEl = toolbar.querySelector('[data-product-count]');
        if (countEl) countEl.textContent = formatPageWindow();
      }
    }
  }

  function formatPageWindow() {
    if (!pageWindow) return '';
    return 'Showing ' + pageWindow.from + '–' + pageWindow.to + ' of ' + pageWindow.total;
  }

  /* ──────────────────────────────────────────────
     Gold count badge on each group heading — Figma 160:82
     ────────────────────────────────────────────── */
  function updateFilterGroupBadges() {
    var groups = document.querySelectorAll('[data-filter-group]');
    Array.prototype.forEach.call(groups, function (group) {
      var badge = group.querySelector('[data-group-badge]');
      if (!badge) return;
      var n = group.querySelectorAll('input[type="checkbox"]:checked').length;
      badge.textContent = n;
      badge.hidden = n === 0;
    });
  }

  /* ──────────────────────────────────────────────
     Show more — Figma 160:117. Groups longer than six rows collapse.
     Runs after the client-side prune so it only counts rows that survived.
     ────────────────────────────────────────────── */
  function initShowMore() {
    var LIMIT = 6;
    var groups = document.querySelectorAll('.filter-group');
    Array.prototype.forEach.call(groups, function (group) {
      var box = group.querySelector('[data-filter-options]');
      var btn = group.querySelector('[data-show-more]');
      if (!box || !btn || btn.getAttribute('data-showmore-wired') === 'true') return;

      var rows = Array.prototype.filter.call(box.children, function (row) {
        return row.style.display !== 'none';
      });
      if (rows.length <= LIMIT) {
        btn.hidden = true;
        return;
      }

      var open = false;
      function render() {
        rows.forEach(function (row, i) {
          row.style.display = (open || i < LIMIT) ? '' : 'none';
        });
        btn.textContent = open ? 'Show less' : 'Show more';
        /* The panel grew or shrank, so its height cap has to be re-measured. */
        refreshSection(group.querySelector('.filter-section-content'));
      }

      btn.hidden = false;
      btn.setAttribute('data-showmore-wired', 'true');
      btn.addEventListener('click', function () {
        open = !open;
        render();
      });
      render();
    });
  }

  /* ──────────────────────────────────────────────
     Sort Dropdown
     ────────────────────────────────────────────── */
  function initSortDropdown() {
    var btn = document.getElementById('sort-dropdown-btn');
    var menu = document.getElementById('sort-dropdown-menu');
    var chevron = document.getElementById('sort-chevron');
    if (!btn || !menu) return;

    var isOpen = false;

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      isOpen = !isOpen;
      toggleDropdown();
    });

    document.addEventListener('click', function (e) {
      if (isOpen && !menu.contains(e.target)) {
        isOpen = false;
        toggleDropdown();
      }
    });

    function toggleDropdown() {
      /* The button is declared aria-haspopup="listbox"; without keeping
         aria-expanded in step it announces itself as collapsed the whole time
         the menu is on screen. */
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        menu.classList.remove('hidden');
        if (chevron) chevron.style.transform = 'rotate(180deg)';
      } else {
        menu.classList.add('hidden');
        if (chevron) chevron.style.transform = 'rotate(0deg)';
      }
    }

    /* Sort options navigate to URL with sort_by param */
    var sortOptions = menu.querySelectorAll('.sort-option');
    sortOptions.forEach(function (option) {
      option.addEventListener('click', function (e) {
        /* Default link behavior handles navigation */
        isOpen = false;
        toggleDropdown();
      });
    });
  }

  /* ──────────────────────────────────────────────
     Grid Column Toggle
     ────────────────────────────────────────────── */
  function initGridToggle() {
    var grid = document.getElementById('product-grid');
    var buttons = document.querySelectorAll('.grid-toggle-btn');
    if (!grid || !buttons.length) return;

    var gridClassMap = {
      '2': 'grid-cols-2',
      '3': 'grid-cols-2 lg:grid-cols-3',
      '4': 'grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
    };

    /* Remove all grid-cols classes */
    function clearGridClasses() {
      var classes = grid.className.split(' ').filter(function (c) {
        return !c.match(/^(grid-cols-|sm:grid-cols-|lg:grid-cols-|xl:grid-cols-)/);
      });
      grid.className = classes.join(' ');
    }

    var STORE_KEY = 'aykah:collection-columns';

    /* aria-checked is the single source of truth: it is what the toolbar's
       stylesheet keys the navy tile off, and what a screen reader reads out of
       the radiogroup. The old handler only swapped utility classes, which the
       id-scoped toolbar rules outrank, so clicking moved nothing and the
       radiogroup always announced the same button as selected. */
    function setActive(cols) {
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-cols') === cols;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.classList.toggle('is-active', on);
      });
    }

    function applyColumns(cols) {
      clearGridClasses();
      var newClasses = gridClassMap[cols];
      if (!newClasses) return false;
      newClasses.split(' ').forEach(function (c) {
        grid.classList.add(c);
      });
      grid.setAttribute('data-cols', cols);
      setActive(cols);
      return true;
    }

    /* The toolbar and the grid are separate sections, so the toolbar cannot see
       the grid's "default columns" setting and ships with the 3-up tile marked.
       Reconcile against what the grid actually rendered, then let a stored
       preference win so the choice survives sorting and pagination. */
    var stored = null;
    try { stored = window.localStorage.getItem(STORE_KEY); } catch (e) { /* private mode */ }

    if (stored && gridClassMap[stored]) {
      applyColumns(stored);
    } else {
      setActive(grid.getAttribute('data-cols') || '3');
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-cols');
        if (!applyColumns(cols)) return;
        try { window.localStorage.setItem(STORE_KEY, cols); } catch (e) { /* private mode */ }
      });
    });
  }

  /* ──────────────────────────────────────────────
     Mobile Filter Drawer
     ────────────────────────────────────────────── */
  function initMobileFilterDrawer() {
    var openBtn = document.getElementById('mobile-filter-btn');
    var closeBtn = document.getElementById('filter-drawer-close');
    var applyBtn = document.getElementById('filter-drawer-apply');
    var drawer = document.getElementById('filter-drawer');
    var backdrop = document.getElementById('filter-drawer-backdrop');
    var overlay = document.getElementById('filter-drawer-overlay');

    if (!drawer) return;

    var filterDrawerOpen = false;
    var filterTriggerElement = null;

    /* ── Focus trap helpers ── */
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function getDrawerFocusable() {
      return Array.prototype.slice.call(drawer.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function handleFilterFocusTrap(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeDrawer();
        return;
      }
      if (e.key !== 'Tab') return;
      var focusable = getDrawerFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function openDrawer() {
      filterTriggerElement = document.activeElement;
      filterDrawerOpen = true;
      backdrop.classList.remove('invisible');
      backdrop.classList.add('visible');
      overlay.classList.remove('opacity-0');
      overlay.classList.add('opacity-100');
      drawer.classList.remove('-translate-x-full');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('translate-x-0');
      document.body.style.overflow = 'hidden';
      /* Trap focus inside drawer */
      drawer.addEventListener('keydown', handleFilterFocusTrap);
      setTimeout(function () {
        var target = closeBtn || getDrawerFocusable()[0];
        if (target) target.focus();
      }, 100);
    }

    function closeDrawer() {
      if (!filterDrawerOpen) return;
      filterDrawerOpen = false;
      drawer.classList.remove('translate-x-0');
      drawer.classList.add('-translate-x-full');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('opacity-100');
      overlay.classList.add('opacity-0');
      setTimeout(function () {
        backdrop.classList.remove('visible');
        backdrop.classList.add('invisible');
      }, 300);
      document.body.style.overflow = '';
      drawer.removeEventListener('keydown', handleFilterFocusTrap);
      /* Restore focus to the element that opened the drawer */
      if (filterTriggerElement && filterTriggerElement.focus) {
        filterTriggerElement.focus();
        filterTriggerElement = null;
      }
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) {
      backdrop.addEventListener('click', function (e) {
        if (e.target === backdrop || e.target === overlay) {
          closeDrawer();
        }
      });
    }

    /* Escape key to close filter drawer */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && filterDrawerOpen) closeDrawer();
    });

    /* Apply button: collect mobile filter form values and navigate */
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        submitFilterForm('filter-form-mobile');
        closeDrawer();
      });
    }
  }

  /* ──────────────────────────────────────────────
     Price Range Dual-Thumb Slider
     ────────────────────────────────────────────── */

  /* Global drag state — only one slider can be dragged at a time */
  var activeSlider = null;

  function initPriceRangeSliders() {
    var sliders = document.querySelectorAll('.price-range-slider');
    sliders.forEach(function (slider) {
      initPriceSlider(slider);
    });

    /* Single set of window-level listeners shared by all slider instances.
       This prevents the "extreme jumps" bug where multiple window listeners
       from different slider instances would conflict. */
    window.addEventListener('pointermove', function (e) {
      if (activeSlider && activeSlider.onMove) {
        activeSlider.onMove(e);
      }
    });
    window.addEventListener('pointerup', function () {
      if (activeSlider && activeSlider.onUp) {
        activeSlider.onUp();
      }
    });
  }

  function initPriceSlider(container) {
    var track = container.querySelector('.price-range-track');
    var fill = container.querySelector('.price-range-fill');
    var thumbMin = container.querySelector('.price-range-thumb-min');
    var thumbMax = container.querySelector('.price-range-thumb-max');
    var inputMin = container.querySelector('.price-range-input-min');
    var inputMax = container.querySelector('.price-range-input-max');
    var tooltipMin = container.querySelector('.price-range-tooltip-min');
    var tooltipMax = container.querySelector('.price-range-tooltip-max');
    var rangeLabel = container.querySelector('.price-range-label');
    var applyBtn = container.querySelector('.price-range-apply-btn');

    if (!track || !thumbMin || !thumbMax || !inputMin || !inputMax) return;

    var min = parseFloat(container.getAttribute('data-min')) || 0;
    var max = parseFloat(container.getAttribute('data-max'));
    var currentMin = parseFloat(container.getAttribute('data-current-min'));
    var currentMax = parseFloat(container.getAttribute('data-current-max'));

    /* Store initial values to detect changes */
    var initialMin = currentMin;
    var initialMax = currentMax;

    /* Validate — skip if Shopify didn't provide valid range */
    if (!max || max <= 0 || isNaN(max)) {
      return;
    }

    /* Set sane defaults */
    if (isNaN(currentMin) || currentMin < min) currentMin = min;
    if (isNaN(currentMax) || currentMax > max || currentMax <= 0) currentMax = max;
    initialMin = currentMin;
    initialMax = currentMax;
    var dragging = null; /* 'min' | 'max' | null */
    var STEP = 10;
    var GAP = STEP; /* Minimum gap between thumbs */

    function getPercent(val) {
      if (max === min) return 0;
      return ((val - min) / (max - min)) * 100;
    }

    /**
     * Convert a clientX pointer position to a dollar value on the price scale.
     * Uses the track's bounding rect — which correctly accounts for the mx-3
     * margin (getBoundingClientRect returns the border box, not the margin box).
     */
    function getValueFromX(clientX) {
      var rect = track.getBoundingClientRect();
      /* Guard: if track is hidden (e.g. mobile drawer closed) width=0 */
      if (rect.width <= 0) return currentMin;
      var pct = (clientX - rect.left) / rect.width;
      pct = Math.max(0, Math.min(1, pct));
      var raw = min + pct * (max - min);
      return Math.round(raw / STEP) * STEP;
    }

    function clampValues() {
      currentMin = Math.max(min, currentMin);
      currentMax = Math.min(max, currentMax);
      if (currentMax - currentMin < GAP) {
        if (dragging === 'min') {
          currentMin = currentMax - GAP;
        } else {
          currentMax = currentMin + GAP;
        }
      }
      currentMin = Math.max(min, currentMin);
      currentMax = Math.min(max, currentMax);
    }

    /* Format dollar amount */
    function formatDollar(val) {
      return '$' + Math.round(val).toLocaleString('en-US');
    }

    function updateUI() {
      clampValues();
      var leftPct = getPercent(currentMin);
      var rightPct = getPercent(currentMax);
      fill.style.left = leftPct + '%';
      fill.style.width = (rightPct - leftPct) + '%';
      /* Centre the handle on its value by measuring it rather than assuming a
         size: the offset used to be hard-coded at half of a 28px thumb, so the
         16px handles in the Figma design hung 6px past the rail. */
      var halfThumb = (thumbMin.offsetWidth || 16) / 2;
      thumbMin.style.left = 'calc(' + leftPct + '% - ' + halfThumb + 'px)';
      thumbMax.style.left = 'calc(' + rightPct + '% - ' + halfThumb + 'px)';
      inputMin.value = Math.floor(currentMin);
      inputMax.value = Math.ceil(currentMax);

      /* Keep ARIA in sync */
      thumbMin.setAttribute('aria-valuenow', Math.floor(currentMin));
      thumbMin.setAttribute('aria-valuetext', '$' + Math.floor(currentMin));
      thumbMax.setAttribute('aria-valuenow', Math.ceil(currentMax));
      thumbMax.setAttribute('aria-valuetext', '$' + Math.ceil(currentMax));

      /* Update range label */
      if (rangeLabel) {
        rangeLabel.textContent = formatDollar(currentMin) + ' \u2013 ' + formatDollar(currentMax);
      }

      /* Update tooltips position (they follow the thumb) */
      if (tooltipMin) {
        tooltipMin.style.left = leftPct + '%';
        tooltipMin.textContent = formatDollar(currentMin);
      }
      if (tooltipMax) {
        tooltipMax.style.left = rightPct + '%';
        tooltipMax.textContent = formatDollar(currentMax);
      }

      /* Show/hide Apply button on desktop when values changed from initial */
      showApplyIfChanged();
    }

    function showApplyIfChanged() {
      if (!applyBtn) return;
      var changed = Math.floor(currentMin) !== Math.floor(initialMin) ||
                    Math.ceil(currentMax) !== Math.ceil(initialMax);
      if (changed) {
        applyBtn.style.opacity = '1';
        applyBtn.style.maxHeight = '40px';
        applyBtn.style.marginTop = '12px';
        applyBtn.style.paddingTop = '8px';
        applyBtn.style.paddingBottom = '8px';
      } else {
        applyBtn.style.opacity = '0';
        applyBtn.style.maxHeight = '0';
        applyBtn.style.marginTop = '0';
        applyBtn.style.paddingTop = '0';
        applyBtn.style.paddingBottom = '0';
      }
    }

    /* Show tooltip */
    function showTooltip(which) {
      var tooltip = which === 'min' ? tooltipMin : tooltipMax;
      if (tooltip) tooltip.style.opacity = '1';
    }

    /* Hide tooltip */
    function hideTooltip(which) {
      var tooltip = which === 'min' ? tooltipMin : tooltipMax;
      if (tooltip) tooltip.style.opacity = '0';
    }

    updateUI();

    /* ── Drag handlers (called from the shared window listener) ── */
    function onMove(e) {
      if (!dragging) return;
      var val = getValueFromX(e.clientX);
      if (dragging === 'min') {
        currentMin = val;
      } else {
        currentMax = val;
      }
      updateUI();
    }

    function onUp() {
      if (!dragging) return;
      var which = dragging;
      dragging = null;
      activeSlider = null;
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
      hideTooltip(which);

      /* On desktop: show Apply button instead of auto-submitting immediately.
         This gives users explicit control over when the filter is applied. */
      var form = container.closest('form');
      if (form && form.id === 'filter-form-desktop' && !applyBtn) {
        /* Fallback: auto-submit if no Apply button */
        scheduleSubmit(600);
      }
    }

    /* Expose handlers for the shared window listener */
    container._sliderHandlers = { onMove: onMove, onUp: onUp };

    /* Thumb pointerdown — start drag */
    thumbMin.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      e.stopPropagation();
      dragging = 'min';
      activeSlider = container._sliderHandlers;
      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'grabbing';
      showTooltip('min');
    });

    thumbMax.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      e.stopPropagation();
      dragging = 'max';
      activeSlider = container._sliderHandlers;
      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'grabbing';
      showTooltip('max');
    });

    /* Track click — jump nearest thumb to click position */
    track.addEventListener('click', function (e) {
      if (e.target === thumbMin || e.target === thumbMax) return;
      var val = getValueFromX(e.clientX);
      var distLow = Math.abs(val - currentMin);
      var distHigh = Math.abs(val - currentMax);
      if (distLow <= distHigh) {
        dragging = 'min';
        currentMin = val;
      } else {
        dragging = 'max';
        currentMax = val;
      }
      updateUI();
      dragging = null;
    });

    /* ── Keyboard navigation (accessibility) ── */
    function handleThumbKeydown(thumb, e) {
      var current = thumb === 'min' ? currentMin : currentMax;
      var newVal = null;

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowUp':
          e.preventDefault();
          newVal = current + STEP;
          break;
        case 'ArrowLeft':
        case 'ArrowDown':
          e.preventDefault();
          newVal = current - STEP;
          break;
        case 'Home':
          e.preventDefault();
          newVal = min;
          break;
        case 'End':
          e.preventDefault();
          newVal = max;
          break;
        case 'Enter':
          e.preventDefault();
          scheduleSubmit(0);
          return;
        default:
          return;
      }

      dragging = thumb;
      if (thumb === 'min') {
        currentMin = newVal;
      } else {
        currentMax = newVal;
      }
      updateUI();
      dragging = null;
    }

    thumbMin.addEventListener('keydown', function (e) {
      handleThumbKeydown('min', e);
    });

    thumbMax.addEventListener('keydown', function (e) {
      handleThumbKeydown('max', e);
    });

    /* ── Number inputs ── */
    inputMin.addEventListener('change', function () {
      var val = parseFloat(inputMin.value);
      if (isNaN(val)) val = min;
      dragging = 'min';
      currentMin = val;
      updateUI();
      dragging = null;
    });

    inputMax.addEventListener('change', function () {
      var val = parseFloat(inputMax.value);
      if (isNaN(val)) val = max;
      dragging = 'max';
      currentMax = val;
      updateUI();
      dragging = null;
    });

    /* Submit on Enter in number inputs */
    inputMin.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var val = parseFloat(inputMin.value);
        if (isNaN(val)) val = min;
        dragging = 'min';
        currentMin = val;
        updateUI();
        dragging = null;
        scheduleSubmit(0);
      }
    });

    inputMax.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var val = parseFloat(inputMax.value);
        if (isNaN(val)) val = max;
        dragging = 'max';
        currentMax = val;
        updateUI();
        dragging = null;
        scheduleSubmit(0);
      }
    });

    /* ── Apply button click ── */
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        scheduleSubmit(0);
      });
    }

    /* ── Helper: schedule form submission ── */
    function scheduleSubmit(delay) {
      var form = container.closest('form');
      if (!form) return;
      /* On mobile, don't auto-submit — the drawer Apply button handles it */
      if (form.id === 'filter-form-mobile' && delay > 0) return;
      clearTimeout(form._submitTimer);
      if (delay <= 0) {
        submitFilterForm(form.id);
      } else {
        form._submitTimer = setTimeout(function () {
          submitFilterForm(form.id);
        }, delay);
      }
    }
  }

  /* ──────────────────────────────────────────────
     Filter Checkbox Changes (Desktop: auto-submit)
     ────────────────────────────────────────────── */
  function initFilterCheckboxes() {
    var desktopForm = document.getElementById('filter-form-desktop');
    if (desktopForm) {
      desktopForm.addEventListener('change', function (e) {
        if (e.target.classList.contains('filter-checkbox')) {
          clearTimeout(desktopForm._submitTimer);
          submitFilterForm('filter-form-desktop');
        }
      });
    }
  }

  /* ──────────────────────────────────────────────
     Filter Section Collapse Toggles
     ────────────────────────────────────────────── */
  /* Open a panel to its measured height, then release the cap.
     The markup opens groups at a flat max-height:500px, which is enough for the
     transition but silently truncates anything taller - and "Show more" can now
     push a group past it. Because .filter-section-content is overflow:visible,
     a truncated panel does not scroll, it overlaps the group beneath it. */
  function openSection(content) {
    content.style.opacity = '1';
    content.style.maxHeight = content.scrollHeight + 'px';
    var release = function () {
      content.style.maxHeight = 'none';
      content.removeEventListener('transitionend', release);
    };
    content.addEventListener('transitionend', release);
  }

  function closeSection(content) {
    /* Animating from 'none' has no start value, so pin the current height and
       force a reflow before collapsing. */
    content.style.maxHeight = content.scrollHeight + 'px';
    void content.offsetHeight;
    content.style.maxHeight = '0px';
    content.style.opacity = '0';
  }

  /* Re-measure a panel that is already open, after its contents changed. */
  function refreshSection(content) {
    if (!content) return;
    var toggle = document.querySelector('[data-target="' + content.id + '"]');
    if (toggle && toggle.getAttribute('aria-expanded') === 'false') return;
    content.style.maxHeight = 'none';
  }

  function initFilterSectionToggles() {
    var toggles = document.querySelectorAll('.filter-section-toggle');
    toggles.forEach(function (toggle) {
      var content = document.getElementById(toggle.getAttribute('data-target'));
      if (!content) return;

      /* Groups that render open have no transition to run, so drop the cap now
         rather than leaving a 500px ceiling on the page's first paint. */
      if (toggle.getAttribute('aria-expanded') === 'true') {
        content.style.maxHeight = 'none';
      }

      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        /* The chevron direction is owned by CSS, keyed on aria-expanded. */
        if (isOpen) closeSection(content);
        else openSection(content);
      });
    });
  }

  /* ──────────────────────────────────────────────
     Globo Preorder availability
     Shopify inventory alone is not enough: Globo can start a preorder campaign
     while a variant still has positive stock. Merge active Globo campaigns into
     the card's filter states, while retaining the Liquid inventory fallback.
     ────────────────────────────────────────────── */
  /* A colour label as written in a variant title vs on the card. */
  function globoColourToken(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function parseGloboConditions(value) {
    if (Array.isArray(value)) return value;
    if (typeof value !== 'string' || !value) return [];
    try {
      var parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function parseGloboDate(value, timezoneOffset) {
    if (!value) return NaN;
    var normalized = String(value);
    if (!/(?:Z|[+-]\d{2}:\d{2})$/.test(normalized)) {
      normalized += timezoneOffset || 'Z';
    }
    return Date.parse(normalized);
  }

  function isActiveGloboPreorder(profile, variant, nowMs, timezoneOffset) {
    if (!profile || Number(profile.status) !== 1 || !variant) return false;

    var startConditions = parseGloboConditions(profile.start_condition);
    var endConditions = parseGloboConditions(profile.end_condition);
    var startDate = null;
    var startStock = null;
    var endDate = null;
    var endQuantity = null;

    startConditions.forEach(function (condition) {
      if (condition.type === 'date') startDate = condition;
      if (condition.type === 'stock') startStock = condition;
    });
    endConditions.forEach(function (condition) {
      if (condition.type === 'date') endDate = condition;
      if (condition.type === 'quantity') endQuantity = condition;
    });

    if (startDate && startDate.condition) {
      var startsAt = parseGloboDate(startDate.condition, timezoneOffset);
      if (!isNaN(startsAt) && nowMs < startsAt) return false;
    }

    if (endDate && endDate.condition) {
      var endsAt = parseGloboDate(endDate.condition, timezoneOffset);
      if (!isNaN(endsAt) && nowMs > endsAt) return false;
    }

    var quantity = Number(variant.inventory_quantity);
    if (startStock && startStock.condition === 'outofstock') {
      var outOfStockAt = Number(startStock.value);
      if (isNaN(quantity) || quantity > (isNaN(outOfStockAt) ? 0 : outOfStockAt)) {
        return false;
      }
    } else if (startStock && startStock.condition === 'instock') {
      var inStockAt = Number(startStock.value);
      if (isNaN(quantity) || quantity <= (isNaN(inStockAt) ? 0 : inStockAt)) {
        return false;
      }
    }

    if (endQuantity && endQuantity.condition !== null && endQuantity.condition !== '') {
      var quantityLimit = Number(endQuantity.condition);
      if (!isNaN(quantity) && !isNaN(quantityLimit) && quantity <= quantityLimit) {
        return false;
      }
    }

    return true;
  }

  function syncGloboPreorderFilterStates(productCards) {
    var params = window.GloboPreorderParams;
    var preorderSettings = params && params.preorderSettings;
    var preorderProducts = preorderSettings && preorderSettings.products;
    var profiles = preorderSettings && preorderSettings.profiles;
    var products = params && params.products;

    if (!preorderProducts || !profiles || !Array.isArray(products)) return;

    var productsByHandle = {};
    products.forEach(function (product) {
      if (product && product.handle) productsByHandle[product.handle] = product;
    });

    var timezoneOffset = params.timezone_offset || '';
    var nowMs = parseGloboDate(params.now, timezoneOffset);
    if (isNaN(nowMs)) nowMs = Date.now();

    productCards.forEach(function (card) {
      var productSignal = card.querySelector('[data-product-handle]');
      var handle = productSignal && productSignal.getAttribute('data-product-handle');
      var product = handle && productsByHandle[handle];
      var variantProfiles = product && preorderProducts[String(product.id)];

      if (!product || !variantProfiles || !Array.isArray(product.variants)) return;

      /* Scope to the colour this card stands for. Every colourway card of a product
         carries the same handle, so scanning the whole product handed "Zir, Truffle Grey"
         the campaign that belongs to Vanilla Bean and filed a fully stocked colour under
         Pre-order. The Liquid already narrows its own state this way; this is the same
         rule applied to the runtime merge. Globo's variant objects expose only `title`
         ("Vanilla Bean / Double"), so match a title segment. If the colour matches no
         variant, keep all of them rather than silently dropping a real campaign. */
      var candidateVariants = product.variants;
      var cardColour = card.getAttribute('data-card-colour');
      if (cardColour) {
        var wanted = globoColourToken(cardColour);
        var scoped = candidateVariants.filter(function (variant) {
          return String(variant.title || '').split('/').some(function (part) {
            return globoColourToken(part) === wanted;
          });
        });
        if (scoped.length) candidateVariants = scoped;
      }

      var hasActivePreorder = candidateVariants.some(function (variant) {
        var profileId = variantProfiles[String(variant.id)];
        var profile = profileId !== undefined && profiles[String(profileId)];
        return isActiveGloboPreorder(profile, variant, nowMs, timezoneOffset);
      });

      if (!hasActivePreorder) return;

      var currentStates = (card.getAttribute('data-product-filter-availability') || '')
        .split('|||')
        .filter(Boolean);
      if (currentStates.indexOf('preorder') === -1) currentStates.push('preorder');
      card.setAttribute('data-product-filter-availability', currentStates.join('|||'));
    });
  }

  /* ──────────────────────────────────────────────
     Client-Side Filters (Category, Color, Material, Size)
     Instant show/hide without page reload.
     ────────────────────────────────────────────── */
  function initClientSideFilters() {
    var allCheckboxes = document.querySelectorAll('.client-filter-checkbox');
    if (!allCheckboxes.length) return;

    var productCards = document.querySelectorAll('.product-card[data-product-type]');
    syncGloboPreorderFilterStates(productCards);
    var clearAllBtn = document.getElementById('clear-all-filters-btn');
    var drawerClearBtn = document.getElementById('filter-drawer-clear-client');
    var drawerApplyBtn = document.getElementById('filter-drawer-close-apply');
    var drawerCloseBtn = document.getElementById('filter-drawer-close');
    /* Scoped to the toolbar on purpose: the title band carries a
       [data-product-count] too, and an unscoped query rewrote the band's
       "126 products" every time a filter changed. */
    var productCountEl = document.querySelector('#collection-toolbar [data-product-count]');

    /* Map filter-type → data-attribute name */
    var filterAttrMap = {
      type: 'data-product-type',
      color: 'data-product-colors',
      material: 'data-product-materials',
      size: 'data-product-sizes',
      availability: 'data-product-filter-availability'
    };

    /* ── Options must relate to the products actually on this page ──
       The option lists are rendered from a collection-wide scan, which can
       include values no visible card carries. Prune any option that matches
       zero cards here, and collapse groups left with nothing to offer. */
    function pruneFilterOptions() {
      var present = { type: {}, color: {}, material: {}, size: {} };
      productCards.forEach(function (card) {
        for (var t in present) {
          var raw = (card.getAttribute(filterAttrMap[t]) || '').toLowerCase();
          raw.split('|||').forEach(function (part) {
            part = part.trim();
            if (part) present[t][part] = true;
          });
        }
      });
      allCheckboxes.forEach(function (cb) {
        var t = cb.getAttribute('data-filter-type');
        if (!present[t]) return; /* availability etc. stay */
        var label = cb.closest('label');
        if (!label) return;
        var val = cb.value.toLowerCase().trim();
        label.style.display = present[t][val] ? '' : 'none';
      });
      /* Collapse groups whose every option got pruned */
      document.querySelectorAll('.filter-section-content').forEach(function (content) {
        var boxes = content.querySelectorAll('.client-filter-checkbox');
        if (!boxes.length) return;
        var prunable = false, anyVisible = false;
        boxes.forEach(function (cb) {
          var t = cb.getAttribute('data-filter-type');
          if (!present[t]) { anyVisible = true; return; }
          prunable = true;
          var label = cb.closest('label');
          if (label && label.style.display !== 'none') anyVisible = true;
        });
        if (prunable && !anyVisible) {
          var group = content.parentElement;
          if (group) group.style.display = 'none';
        }
      });
    }
    pruneFilterOptions();

    /* ── Visual checkbox state update ── */
    function updateCheckboxVisual(checkbox) {
      var label = checkbox.closest('label');
      if (!label) return;
      var filterType = checkbox.getAttribute('data-filter-type');

      if (filterType === 'color') {
        /* Color swatch: add/remove ring */
        var swatch = label.querySelector('span');
        if (!swatch) return;
        if (checkbox.checked) {
          swatch.classList.add('ring-2', 'ring-brand-accent-btn', 'ring-offset-2');
          swatch.classList.remove('hover:ring-brand-border', 'hover:ring-offset-1');
        } else {
          swatch.classList.remove('ring-2', 'ring-brand-accent-btn', 'ring-offset-2');
          swatch.classList.add('hover:ring-brand-border', 'hover:ring-offset-1');
        }
      } else {
        /* Checkbox: toggle bg and checkmark */
        var box = label.querySelector('span');
        var svg = box ? box.querySelector('svg') : null;
        if (!box) return;
        if (checkbox.checked) {
          box.classList.add('bg-brand-accent-btn', 'border-brand-accent-btn');
          box.classList.remove('border-brand-border', 'bg-white');
          if (svg) {
            svg.classList.add('opacity-100', 'scale-100');
            svg.classList.remove('opacity-0', 'scale-50');
          }
        } else {
          box.classList.remove('bg-brand-accent-btn', 'border-brand-accent-btn');
          box.classList.add('border-brand-border', 'bg-white');
          if (svg) {
            svg.classList.remove('opacity-100', 'scale-100');
            svg.classList.add('opacity-0', 'scale-50');
          }
        }
      }
    }

    /* ── Sync desktop ↔ mobile checkboxes ── */
    function syncCheckbox(changed) {
      var filterType = changed.getAttribute('data-filter-type');
      var val = changed.value;
      var isChecked = changed.checked;

      allCheckboxes.forEach(function (cb) {
        if (cb !== changed &&
            cb.getAttribute('data-filter-type') === filterType &&
            cb.value === val) {
          cb.checked = isChecked;
          updateCheckboxVisual(cb);
        }
      });
    }

    /* ── Collect active filters → { type: [...], color: [...], ... } ── */
    function getActiveFilters() {
      var active = {};
      /* Only read from desktop form to avoid double-counting synced checkboxes */
      var desktopForm = document.getElementById('filter-form-desktop');
      var scope = desktopForm || document;
      var checked = scope.querySelectorAll('.client-filter-checkbox:checked');
      checked.forEach(function (cb) {
        var t = cb.getAttribute('data-filter-type');
        if (!active[t]) active[t] = [];
        active[t].push(cb.value.toLowerCase());
      });
      return active;
    }

    function restoreClientFiltersFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var restored = {};

      CLIENT_FILTER_TYPES.forEach(function (filterType) {
        restored[filterType] = params.getAll(CLIENT_FILTER_PARAM_PREFIX + filterType)
          .map(function (value) { return value.toLowerCase(); });
      });

      allCheckboxes.forEach(function (cb) {
        var filterType = cb.getAttribute('data-filter-type');
        var values = restored[filterType] || [];
        cb.checked = values.indexOf(cb.value.toLowerCase()) !== -1;
        updateCheckboxVisual(cb);
      });
    }

    function syncClientFiltersToUrl(active) {
      var url = new URL(window.location.href);

      CLIENT_FILTER_TYPES.forEach(function (filterType) {
        url.searchParams.delete(CLIENT_FILTER_PARAM_PREFIX + filterType);
      });

      CLIENT_FILTER_TYPES.forEach(function (filterType) {
        var values = active[filterType] || [];
        values.forEach(function (value) {
          url.searchParams.append(CLIENT_FILTER_PARAM_PREFIX + filterType, value);
        });
      });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      }
      syncCollectionStateLinks();
    }

    /* ── Apply filters to product cards ── */
    function applyFilters() {
      var active = getActiveFilters();
      var hasAny = Object.keys(active).length > 0;
      var visibleCount = 0;

      productCards.forEach(function (card) {
        if (!hasAny) {
          card.removeAttribute('data-filtered');
          visibleCount++;
          return;
        }

        var match = true;
        for (var filterType in active) {
          if (!active.hasOwnProperty(filterType)) continue;
          var attrName = filterAttrMap[filterType];
          if (!attrName) continue;

          var cardVal = (card.getAttribute(attrName) || '').toLowerCase();
          var filterValues = active[filterType];

          /* Card must match at least ONE selected value in this group */
          var groupMatch = false;

          /* Availability uses the same exact variant rule as the PDP and
             structured data. A product can expose both in-stock and preorder
             variants, so its filter attribute may contain multiple states. */
          if (filterType === 'availability') {
            var availabilityParts = cardVal.split('|||');
            for (var i = 0; i < filterValues.length; i++) {
              for (var j = 0; j < availabilityParts.length; j++) {
                if (availabilityParts[j].trim() === filterValues[i]) {
                  groupMatch = true;
                  break;
                }
              }
              if (groupMatch) break;
            }
          } else {
            for (var i = 0; i < filterValues.length; i++) {
              /* For multi-value attrs (color, material, size) split by ||| */
              var cardParts = cardVal.split('|||');
              for (var j = 0; j < cardParts.length; j++) {
                if (cardParts[j].trim() === filterValues[i]) {
                  groupMatch = true;
                  break;
                }
              }
              if (groupMatch) break;
            }
          }

          if (!groupMatch) {
            match = false;
            break; /* AND logic between filter groups */
          }
        }

        if (match) {
          card.removeAttribute('data-filtered');
          visibleCount++;
        } else {
          card.setAttribute('data-filtered', 'hidden');
        }
      });

      /* Update product count if visible */
      if (productCountEl) {
        if (hasAny) {
          productCountEl.textContent = pageWindow
            ? 'Showing ' + visibleCount + ' of ' + pageWindow.total
            : visibleCount + ' product' + (visibleCount !== 1 ? 's' : '');
        } else {
          productCountEl.textContent = pageWindow
            ? formatPageWindow()
            : visibleCount + ' product' + (visibleCount !== 1 ? 's' : '');
        }
      }

      /* Show/hide clear button */
      updateClearButton(hasAny);

      /* Figma 160:82 / 163:23 — heading badges and the chip row read straight
         off the checkbox state, so they refresh with every filter change. */
      updateFilterGroupBadges();
      renderClientChips();
      syncClientFiltersToUrl(active);

      /* Show "no results" message */
      showNoResults(hasAny && visibleCount === 0);
    }

    /* ── Chips for the client-side selections — Figma 163:23 ──
       The native (Shopify-filter) chips are rendered server-side; these are
       added beside them and are the only ones this function ever removes. */
    var chipRow = document.querySelector('#collection-toolbar .toolbar-chiprow');
    var chipClear = document.getElementById('chiprow-clear-all');
    var chipTemplate = document.getElementById('filter-chip-template');

    function renderClientChips() {
      if (!chipRow || !chipTemplate) return;

      var stale = chipRow.querySelectorAll('[data-client-chip]');
      Array.prototype.forEach.call(stale, function (el) {
        el.parentNode.removeChild(el);
      });

      var checked = document.querySelectorAll('#desktop-filters .client-filter-checkbox:checked');
      Array.prototype.forEach.call(checked, function (cb) {
        var label = cb.closest('label');
        if (!label) return;

        var type = cb.getAttribute('data-filter-type');
        var textEl = label.querySelector('span:last-of-type');
        var text = (type === 'color' || !textEl) ? cb.value : textEl.textContent.trim();

        var chip = chipTemplate.content.firstElementChild.cloneNode(true);
        chip.setAttribute('data-client-chip', type + '|' + cb.value);
        chip.querySelector('[data-chip-label]').textContent = text;

        var x = chip.querySelector('.filter-chip-x');
        x.setAttribute('aria-label', 'Remove ' + text + ' filter');
        x.addEventListener('click', function () {
          cb.checked = false;
          updateCheckboxVisual(cb);
          syncCheckbox(cb);
          applyFilters();
        });

        if (chipClear && chipClear.parentNode === chipRow) {
          chipRow.insertBefore(chip, chipClear);
        } else {
          chipRow.appendChild(chip);
        }
      });

      if (chipClear) {
        chipClear.hidden = chipRow.querySelectorAll('.filter-chip').length === 0;
      }
    }

    if (chipClear) {
      chipClear.addEventListener('click', function (e) {
        var hasClient = document.querySelectorAll('.client-filter-checkbox:checked').length > 0;
        var hasNative = document.querySelectorAll('.filter-checkbox:checked').length > 0 ||
          window.location.search.indexOf('filter.') !== -1;
        /* Nothing to reload for when only the in-page filters are on */
        if (hasClient && !hasNative) {
          e.preventDefault();
          clearAllClientFilters();
        }
      });
    }

    /* ── Clear button visibility ── */
    function updateClearButton(hasClientFilters) {
      if (!clearAllBtn) return;
      if (hasClientFilters) {
        clearAllBtn.classList.remove('hidden');
      }
      /* Don't hide if Shopify native filters are active (it's also a link to collection URL) */
    }

    /* ── No results message ── */
    var noResultsEl = null;
    function showNoResults(show) {
      var grid = document.getElementById('product-grid');
      if (!grid) return;

      if (show) {
        if (!noResultsEl) {
          noResultsEl = document.createElement('div');
          noResultsEl.className = 'col-span-full flex flex-col items-center justify-center py-16 text-center';
          noResultsEl.innerHTML = '<svg class="w-16 h-16 text-brand-text-light/30 mb-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"/></svg>' +
            '<p class="text-lg font-medium text-foreground mb-1">No products match your filters</p>' +
            '<p class="text-sm text-brand-text-muted mb-4">Try adjusting or clearing your filters</p>' +
            '<button type="button" class="text-sm font-medium text-brand-accent-text hover:text-brand-accent-btn underline underline-offset-2 transition-colors" id="no-results-clear-btn">Clear All Filters</button>';
          noResultsEl.id = 'no-results-message';
        }
        if (!grid.contains(noResultsEl)) {
          grid.appendChild(noResultsEl);
        }
        /* Attach clear handler */
        var nrClearBtn = noResultsEl.querySelector('#no-results-clear-btn');
        if (nrClearBtn) {
          nrClearBtn.onclick = clearAllClientFilters;
        }
      } else {
        if (noResultsEl && noResultsEl.parentNode) {
          noResultsEl.parentNode.removeChild(noResultsEl);
        }
      }
    }

    /* ── Clear all client-side filters ── */
    function clearAllClientFilters() {
      allCheckboxes.forEach(function (cb) {
        cb.checked = false;
        updateCheckboxVisual(cb);
      });
      applyFilters();
    }

    /* Restore custom filter state before the first render. This makes a
       refreshed, shared, or paginated URL reproduce the same selection. */
    restoreClientFiltersFromUrl();
    applyFilters();

    /* ── Listen for changes on all client checkboxes ── */
    allCheckboxes.forEach(function (cb) {
      cb.addEventListener('change', function () {
        updateCheckboxVisual(cb);
        syncCheckbox(cb);
        applyFilters();
      });
    });

    /* ── Clear All button — also clears client filters ── */
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function (e) {
        /* Check if any client filters are active */
        var active = getActiveFilters();
        var hasClientFilters = Object.keys(active).length > 0;

        if (hasClientFilters) {
          /* Clear client filters */
          clearAllClientFilters();

          /* If no Shopify native filters are active, prevent navigation */
          var hasNativeFilters = false;
          var nativeChecked = document.querySelectorAll('.filter-checkbox:checked');
          if (nativeChecked.length > 0) hasNativeFilters = true;
          /* Check price range */
          var urlParams = new URLSearchParams(window.location.search);
          urlParams.forEach(function (val, key) {
            if (key.indexOf('filter.v.price') > -1) hasNativeFilters = true;
          });

          if (!hasNativeFilters) {
            e.preventDefault();
          }
        }
      });
    }

    /* ── Mobile drawer: Clear button ── */
    if (drawerClearBtn) {
      drawerClearBtn.addEventListener('click', function () {
        /* Clear client filters in mobile */
        var mobileCbs = document.querySelectorAll('#filter-form-mobile .client-filter-checkbox');
        mobileCbs.forEach(function (cb) {
          cb.checked = false;
          updateCheckboxVisual(cb);
        });
        /* Sync to desktop */
        allCheckboxes.forEach(function (cb) {
          cb.checked = false;
          updateCheckboxVisual(cb);
        });
        applyFilters();
      });
    }

    /* ── Mobile drawer: Apply button ── */
    if (drawerApplyBtn) {
      drawerApplyBtn.addEventListener('click', function () {
        /* Sync mobile → desktop first */
        var mobileCbs = document.querySelectorAll('#filter-form-mobile .client-filter-checkbox');
        mobileCbs.forEach(function (mcb) {
          syncCheckbox(mcb);
        });
        applyFilters();

        /* Also submit Shopify native filters if any */
        var nativeChecked = document.querySelectorAll('#filter-form-mobile .filter-checkbox:checked');
        if (nativeChecked.length > 0) {
          submitFilterForm('filter-form-mobile');
        } else {
          /* Just close drawer if only client filters */
          var drawer = document.getElementById('filter-drawer');
          var backdrop = document.getElementById('filter-drawer-backdrop');
          var overlay = document.getElementById('filter-drawer-overlay');
          if (drawer) {
            drawer.classList.remove('translate-x-0');
            drawer.classList.add('-translate-x-full');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
          }
          if (overlay) {
            overlay.classList.remove('opacity-100');
            overlay.classList.add('opacity-0');
          }
          if (backdrop) {
            setTimeout(function () {
              backdrop.classList.remove('visible');
              backdrop.classList.add('invisible');
            }, 300);
          }
          document.body.style.overflow = '';
        }
      });
    }
  }

  /* ──────────────────────────────────────────────
     Submit Filter Form → navigate to filtered URL

     Shopify storefront filtering price URL params
     accept DOLLARS (e.g. filter.v.price.gte=500 for $500).
     The slider/inputs already work in dollars.

     IMPORTANT: When price is narrowed, we always send BOTH
     gte and lte so Shopify applies a proper bounded range.
     ────────────────────────────────────────────── */
  function submitFilterForm(formId) {
    var form = document.getElementById(formId);
    if (!form) return;

    var params = new URLSearchParams();

    /* Collect checked checkboxes */
    var checkboxes = form.querySelectorAll('.filter-checkbox:checked');
    checkboxes.forEach(function (cb) {
      params.append(cb.name, cb.value);
    });

    /* Collect price range values */
    var priceSliders = form.querySelectorAll('.price-range-slider');
    priceSliders.forEach(function (slider) {
      var minInput = slider.querySelector('.price-range-input-min');
      var maxInput = slider.querySelector('.price-range-input-max');
      var minName = slider.getAttribute('data-filter-min-name');
      var maxName = slider.getAttribute('data-filter-max-name');
      var rangeMin = parseFloat(slider.getAttribute('data-min')) || 0;
      var rangeMax = parseFloat(slider.getAttribute('data-max'));

      if (!minInput || !maxInput || !minName || !maxName) return;

      var minValue = parseFloat(minInput.value);
      var maxValue = parseFloat(maxInput.value);
      if (isNaN(minValue)) minValue = rangeMin;
      if (isNaN(maxValue)) maxValue = rangeMax;

      /* Clamp to valid range */
      minValue = Math.max(rangeMin, Math.min(minValue, rangeMax));
      maxValue = Math.max(rangeMin, Math.min(maxValue, rangeMax));
      if (minValue > maxValue) { var tmp = minValue; minValue = maxValue; maxValue = tmp; }

      /* Only add params if user narrowed the range */
      var isNarrowed = minValue > rangeMin || maxValue < rangeMax;

      if (isNarrowed) {
        /* Always send BOTH gte and lte so Shopify gets a proper bounded range.
           Values are in whole dollars — Shopify accepts dollars in URL params. */
        params.append(minName, Math.round(minValue));
        params.append(maxName, Math.round(maxValue));
      }
    });

    /* Preserve client-side filters and sorting when a Shopify-native filter
       submits. The new native filter values above intentionally reset page=1. */
    var currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach(function (value, key) {
      if (isClientFilterParam(key)) {
        params.append(key, value);
      }
    });
    if (currentParams.has('sort_by')) {
      params.set('sort_by', currentParams.get('sort_by'));
    }

    var baseUrl = window.location.pathname;
    var queryString = params.toString();
    var newUrl = queryString ? baseUrl + '?' + queryString : baseUrl;

    window.location.href = newUrl;
  }
})();
